// Bilingual translations for the luxury rental landing page
export const translations = {
  en: {
    nav: {
      locations: "Locations",
      services: "Services",
      benefits: "Benefits",
      payments: "Payments",
      testimonials: "Testimonials",
      contact: "Contact",
      cta: "Book Consultation",
    },
    hero: {
      eyebrow: "Private Rentals · Cyprus · Turkey · UAE",
      title: "Luxury Rentals Abroad,",
      titleAccent: "Tailored Personally for You.",
      subtitle:
        "A private concierge for international clients. Short and long-term residences in the Mediterranean and the Gulf — carefully selected, confidentially handled, delivered on your terms.",
      primaryCta: "Book Consultation",
      secondaryCta: "Explore Residences",
      pillars: [
        {
          k: "International Clients",
          v: "We work with clients across Europe, the CIS and the Middle East.",
        },
        {
          k: "Personalized Property Search",
          v: "A bespoke brief, a dedicated manager, residences matched to you.",
        },
        {
          k: "Confidential Premium Service",
          v: "Hand-picked addresses in top locations — handled discreetly.",
        },
      ],
      scroll: "Scroll",
    },
    locations: {
      eyebrow: "Our Territories",
      title: "Three Shores. One Standard.",
      subtitle:
        "From the pine-scented coastline of Cyprus to the skyline of Dubai, we curate residences where privacy meets prestige.",
      cyprus: {
        name: "Cyprus",
        tagline: "Mediterranean Serenity",
        description:
          "Sea-view villas in Limassol, Paphos, and Ayia Napa. A destination for year-round living, tax-efficient residency, and quiet luxury.",
        tag: "EU · Schengen-adjacent",
      },
      turkey: {
        name: "Turkey",
        tagline: "Bosphorus & Beyond",
        description:
          "Historic yali on the Bosphorus, penthouse residences in Bodrum and Istanbul. Where heritage meets contemporary architecture.",
        tag: "Istanbul · Bodrum · Antalya",
      },
      uae: {
        name: "UAE",
        tagline: "Skyline of Ambition",
        description:
          "Palm Jumeirah villas, Downtown Dubai penthouses, and branded residences. The global capital of luxury living.",
        tag: "Dubai · Abu Dhabi",
      },
      explore: "Explore",
    },
    services: {
      eyebrow: "Our Services",
      title: "Tailored to Your Tempo.",
      subtitle:
        "Whether a week of seclusion or a year of residency, every engagement begins with a conversation and ends with keys in hand.",
      short: {
        title: "Short-Term Luxury Rentals",
        description:
          "Weekly and monthly residences with concierge service, private chefs, chauffeur, and yacht charter on request.",
      },
      long: {
        title: "Long-Term Residence",
        description:
          "Annual leases for families, executives, and relocations. Full documentation support, residency advice, utilities handled.",
      },
      custom: {
        title: "Bespoke Property Search",
        description:
          "A discreet hunt for your exact brief. Off-market listings, private viewings, negotiated terms. We source what others cannot find.",
      },
    },
    benefits: {
      eyebrow: "Why Clients Choose Us",
      title: "Discretion. Precision. Velocity.",
      items: [
        {
          title: "Verified Properties Only",
          description:
            "Every residence visited, photographed, and vetted by our team. No surprises, no catfishing.",
        },
        {
          title: "Personal Manager",
          description:
            "One dedicated human, end to end. In Russian or English. Available on Telegram, WhatsApp, or phone.",
        },
        {
          title: "Fast Booking Process",
          description:
            "Most reservations confirmed within 24 hours. Contracts in both languages, e-signed and compliant.",
        },
        {
          title: "Crypto & International Payments",
          description:
            "SWIFT, SEPA, USDT, BTC. Multi-currency invoicing. Full accounting transparency for every transaction.",
        },
      ],
    },
    payments: {
      eyebrow: "Payments",
      title: "Global Capital. Frictionless Flow.",
      subtitle:
        "Built for the international client. Pay however makes sense for you — fiat or crypto, fully compliant.",
      methods: [
        {
          name: "Bank Transfer",
          desc: "SWIFT · SEPA · Multi-currency",
        },
        {
          name: "USDT",
          desc: "TRC20 · ERC20",
        },
        {
          name: "Bitcoin",
          desc: "BTC · Escrow available",
        },
        {
          name: "TON",
          desc: "The Open Network",
        },
      ],
      note: "Full KYC and compliance. Transparent invoicing. Receipts in your preferred jurisdiction.",
    },
    map: {
      eyebrow: "Where We Operate",
      title: "A Map of Possibility.",
      subtitle:
        "Three geographies, connected by our network of trusted developers, owners, and private sellers.",
    },
    testimonials: {
      eyebrow: "Testimonials",
      title: "Quiet Words From Quiet Clients.",
      items: [
        {
          quote:
            "I needed a residence in Limassol within 48 hours. They delivered a sea-view villa, private chef arranged, before my flight landed. Faultless.",
          name: "Victoria A.",
          role: "Private Family Office, London",
        },
        {
          quote:
            "Their off-market inventory in Dubai is unmatched. Closed on a Palm villa that was never publicly listed. They operate on a different level.",
          name: "Mr. K. Demir",
          role: "Founder, Fintech Group",
        },
        {
          quote:
            "From Istanbul yali to Bodrum summer house — one manager, one contract. Crypto payment, no friction. This is how business should be done.",
          name: "Alexei V.",
          role: "Investor, Zurich",
        },
      ],
    },
    contact: {
      eyebrow: "Begin the Conversation",
      title: "Your Next Address Starts Here.",
      subtitle:
        "Share a brief and we'll respond within the hour. All communications are private and non-binding.",
      form: {
        name: "Your Name",
        contact: "Phone or Email",
        message: "Tell us about your brief — destinations, dates, preferences.",
        submit: "Send via Telegram",
      },
      quickTelegram: "Message on Telegram",
      prefilledMessage: "Hello! I'm interested in renting a property.",
      direct: "Or reach us directly",
      phoneLabel: "Phone",
      emailLabel: "Email",
      telegramLabel: "Telegram",
    },
    cta: {
      eyebrow: "Ready when you are",
      title: "Get a personalized property search within 24 hours.",
      subtitle:
        "Send a brief to your dedicated manager — destinations, dates, preferences. We reply within the hour and return a curated shortlist the same day.",
      primary: "Book Consultation",
      secondary: "Message on Telegram",
    },
    footer: {
      tagline:
        "International real estate & relocation consulting — discreetly handled.",
      rights: "All rights reserved.",
      regions: "Cyprus · Turkey · UAE",
    },
    brand: {
      name: "NMN Energy Consulting",
      subtitle: "Private Real Estate & Relocation Consulting",
    },
  },
  ru: {
    nav: {
      locations: "Локации",
      services: "Услуги",
      benefits: "Преимущества",
      payments: "Оплата",
      testimonials: "Отзывы",
      contact: "Контакты",
      cta: "Связаться",
    },
    hero: {
      eyebrow: "Частная аренда · Кипр · Турция · ОАЭ",
      title: "Элитная аренда за рубежом,",
      titleAccent: "подобранная лично для Вас.",
      subtitle:
        "Приватный консьерж-сервис для международных клиентов. Краткосрочная и долгосрочная аренда в Средиземноморье и Персидском заливе — тщательно отобранные объекты, конфиденциальное сопровождение, индивидуальные условия.",
      primaryCta: "Связаться",
      secondaryCta: "Смотреть резиденции",
      pillars: [
        {
          k: "Международные клиенты",
          v: "Работаем с клиентами из Европы, СНГ и Ближнего Востока.",
        },
        {
          k: "Индивидуальный подбор",
          v: "ТЗ, персональный менеджер, объекты — строго под Вас.",
        },
        {
          k: "Конфиденциальный premium-сервис",
          v: "Тщательно отобранные адреса в лучших локациях — деликатно.",
        },
      ],
      scroll: "Прокрутка",
    },
    locations: {
      eyebrow: "Наши территории",
      title: "Три побережья. Один стандарт.",
      subtitle:
        "От сосновых берегов Кипра до небоскрёбов Дубая — мы подбираем резиденции, где приватность встречается с престижем.",
      cyprus: {
        name: "Кипр",
        tagline: "Средиземноморское спокойствие",
        description:
          "Виллы с видом на море в Лимассоле, Пафосе и Айя-Напе. Идеально для круглогодичного проживания, налогового планирования и тихой роскоши.",
        tag: "ЕС · рядом с Шенгеном",
      },
      turkey: {
        name: "Турция",
        tagline: "Босфор и далее",
        description:
          "Исторические яли на Босфоре, пентхаусы в Бодруме и Стамбуле. Там, где наследие встречается с современной архитектурой.",
        tag: "Стамбул · Бодрум · Анталья",
      },
      uae: {
        name: "ОАЭ",
        tagline: "Горизонт амбиций",
        description:
          "Виллы на Palm Jumeirah, пентхаусы в Downtown Dubai и брендовые резиденции. Мировая столица роскошной жизни.",
        tag: "Дубай · Абу-Даби",
      },
      explore: "Подробнее",
    },
    services: {
      eyebrow: "Наши услуги",
      title: "Под Ваш ритм.",
      subtitle:
        "Неделя уединения или год проживания — каждая работа начинается с беседы и заканчивается ключами в Вашей руке.",
      short: {
        title: "Краткосрочная аренда",
        description:
          "Апартаменты и виллы на неделю или месяц с консьержем, личным шеф-поваром, водителем и чартером яхт по запросу.",
      },
      long: {
        title: "Долгосрочная аренда",
        description:
          "Годовые контракты для семей, топ-менеджеров и при переезде. Полное юридическое сопровождение, консультации по ВНЖ.",
      },
      custom: {
        title: "Подбор недвижимости",
        description:
          "Конфиденциальный поиск по Вашему техзаданию. Эксклюзивные объекты вне рынка, приватные показы, переговоры по цене.",
      },
    },
    benefits: {
      eyebrow: "Почему выбирают нас",
      title: "Конфиденциальность. Точность. Скорость.",
      items: [
        {
          title: "Только проверенные объекты",
          description:
            "Каждую резиденцию мы лично осматриваем, фотографируем и верифицируем. Без сюрпризов и фейков.",
        },
        {
          title: "Персональный менеджер",
          description:
            "Один выделенный человек от начала до конца. На русском или английском. Доступен в Telegram, WhatsApp и по телефону.",
        },
        {
          title: "Быстрое бронирование",
          description:
            "Большинство броней подтверждаем в течение 24 часов. Двуязычные контракты с электронной подписью.",
        },
        {
          title: "Крипто и международные платежи",
          description:
            "SWIFT, SEPA, USDT, BTC. Мультивалютные счета. Полная прозрачность по каждой транзакции.",
        },
      ],
    },
    payments: {
      eyebrow: "Оплата",
      title: "Глобальный капитал. Без трения.",
      subtitle:
        "Создано для международного клиента. Оплачивайте удобным способом — фиат или крипта, полный compliance.",
      methods: [
        {
          name: "Банковский перевод",
          desc: "SWIFT · SEPA · мультивалюта",
        },
        {
          name: "USDT",
          desc: "TRC20 · ERC20",
        },
        {
          name: "Bitcoin",
          desc: "BTC · возможен эскроу",
        },
        {
          name: "TON",
          desc: "The Open Network",
        },
      ],
      note: "Полный KYC и compliance. Прозрачные счета. Документы в удобной для Вас юрисдикции.",
    },
    map: {
      eyebrow: "География присутствия",
      title: "Карта возможностей.",
      subtitle:
        "Три географии, объединённые сетью доверенных застройщиков, собственников и частных продавцов.",
    },
    testimonials: {
      eyebrow: "Отзывы",
      title: "Тихие слова тихих клиентов.",
      items: [
        {
          quote:
            "Нужна была резиденция в Лимассоле за 48 часов. Подобрали виллу с видом на море, организовали шеф-повара — всё до посадки моего самолёта. Безупречно.",
          name: "Виктория А.",
          role: "Private Family Office, Лондон",
        },
        {
          quote:
            "Их off-market инвентарь в Дубае не имеет аналогов. Купил виллу на Palm, которой не было в открытом доступе. Совершенно другой уровень.",
          name: "Г-н К. Демир",
          role: "Основатель, Fintech Group",
        },
        {
          quote:
            "От яли в Стамбуле до летнего дома в Бодруме — один менеджер, один контракт. Оплата в крипте, без проблем. Вот так должен вестись бизнес.",
          name: "Алексей В.",
          role: "Инвестор, Цюрих",
        },
      ],
    },
    contact: {
      eyebrow: "Начните диалог",
      title: "Ваш следующий адрес начинается здесь.",
      subtitle:
        "Оставьте краткое ТЗ — ответим в течение часа. Любая переписка конфиденциальна и ни к чему не обязывает.",
      form: {
        name: "Ваше имя",
        contact: "Телефон или email",
        message: "Расскажите о задаче — направления, даты, пожелания.",
        submit: "Отправить в Telegram",
      },
      quickTelegram: "Связаться в Telegram",
      prefilledMessage: "Здравствуйте! Интересует аренда недвижимости",
      direct: "Или свяжитесь напрямую",
      phoneLabel: "Телефон",
      emailLabel: "Email",
      telegramLabel: "Telegram",
    },
    cta: {
      eyebrow: "Мы на связи",
      title: "Персональный подбор недвижимости за 24 часа.",
      subtitle:
        "Отправьте ТЗ Вашему персональному менеджеру — направления, даты, пожелания. Отвечаем в течение часа и возвращаем подборку в тот же день.",
      primary: "Book Consultation",
      secondary: "Связаться в Telegram",
    },
    footer: {
      tagline:
        "Международный консалтинг по аренде и релокации — деликатное сопровождение.",
      rights: "Все права защищены.",
      regions: "Кипр · Турция · ОАЭ",
    },
    brand: {
      name: "NMN Energy Consulting",
      subtitle: "Частный консалтинг по недвижимости и релокации",
    },
  },
};

export function detectDefaultLanguage() {
  if (typeof navigator === "undefined") return "en";
  const lang = (navigator.language || "en").toLowerCase();
  return lang.startsWith("ru") ? "ru" : "en";
}
